export default "https://static.ingenie.fr/modules/assets/seats/images/rotate_icon.95d8d2717f5b9071e5e7e07f19195929.svg";